// Auto-generated by scripts/generate-build-info.mjs. Do not edit.
export const buildInfo = {
    commit: '7dc8702',
    builtAt: '2026-08-28T10:46:42.086Z',
} as const;
